<template>
  <div class="animated fadeIn list-of-expense">
    <b-card>
      <div slot="header">
        My Expense Reimbursment
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm"
            >Delete</b-button
          >
          <b-button variant="primary mr-1" @click="print()"
            ><i class="fa fa-print"></i> Print</b-button
          >
          <b-button
            variant="primary mr-1"
            @click="approvalConfirm()"
            v-if="use_wfservice == 1"
            ><i class="fa fa-paper-plane"></i> Approval</b-button
          >
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i>Export</b-button
          >
          <b-button variant="primary mr-1" @click="togleFilter()"
            ><i class="fa fa-filter"></i> Filter</b-button
          >
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Description</label></b-input-group-prepend
            >
            <b-form-input v-model="tblData.uraian"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Dimension Name</label></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.DimCol"
              :plain="true"
              :options="dimension"
            ></b-form-select>
            <b-input-group-prepend
              ><span class="input-group-text"
                >value</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.DimVal"
              placeholder="Dimension Value"
            ></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend
              ><label>Request Date</label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.tgl1"
              type="date"
              style="width: 23% !important"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >until</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.tgl2"
              type="date"
              style="width: 23% !important"
            ></b-form-input>
            <b-input-group-prepend
              ><span class="ml-2 pt-2"
                >Outstand &nbsp;</span
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.outstand"
              :plain="true"
              :options="dataList.YesNoAll"
              style="padding: 0 !important"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Request Number</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.nomor"
                  placeholder="Request Number"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="pt-2"
                    >Pay To &nbsp;</span
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.dibayarke"
                  placeholder="Pay to"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Expense Reimburs Acc.</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.kodeacc"
                  placeholder="Account Code"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="pt-2"
                    >Acc. Name&nbsp;</span
                  ></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.namaacc"
                  placeholder="Account Name"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" class="text-right">
              <b-button class="btn btn-success ml-3" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter</b-button
              >
              <b-button class="btn btn-secondary" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(action)="data">
          <b-dropdown
            dropright
            variant="outline-secondary"
            toggle-class="text-decoration-none"
            no-caret
            size="sm"
            style="margin: -10px"
          >
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item
              @click="rowEdit(data.item)"
              href="#"
              :disabled="
                data.item.posting == 1 ||
                data.item.nomorbank ||
                (data.item.send2wf == 1 && data.item.isreviewed == 0)
              "
              style="padding: 0 !important"
              >Edit</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowPrint(data.item)"
              href="#"
              style="padding: 0 !important"
              >Print Form</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowDel(data.item)"
              href="#"
              :disabled="
                data.item.posting == 1 || (data.item.nomorbank || '') != ''
              "
              style="padding: 0 !important"
            >
              Delete</b-dropdown-item
            >
            <b-dropdown-item
              @click="rowAttachment(data.item)"
              href="#"
              style="padding: 0 !important"
              >Attachment</b-dropdown-item
            >
          </b-dropdown>
        </template>

        <template v-slot:cell(tglRequ)="data">
          {{ data.item.tglRequ | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(jumlah)="data">
          {{ data.item.jumlah | numFormat }}
        </template>
        <template v-slot:cell(nilaiByr)="data">
          {{ data.item.nilaiByr | numFormat }}
        </template>

        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>
        </template>
      </b-table>

      <b-row>
        <b-col cols="5">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="2">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-1 pr-2"
                >Limit per page</span
              ></b-input-group-prepend
            >
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width: 80px"
            />
          </b-input-group>
        </b-col>
        <b-col cols="5">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal
        v-model="showDelConfirm"
        title="Delete Record?"
        :centered="true"
        @ok="deleteData"
      >
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">
          Warning: You can't undo this action.
        </p>
      </b-modal>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="showApprovalConfirm"
      header-bg-variant="primary"
      title="Approval Form"
      size="lg"
      :centered="true"
      hide-footer
    >
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend
              ><label>Request Number</label></b-input-group-prepend
            >
            <b-form-input v-model="model.tglRequ" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><label>Request Date</label></b-input-group-prepend
            >
            <b-form-input
              v-model="model.tglRequ"
              type="date"
              disabled
            ></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-input-group>
        <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
        <b-form-input readonly v-model="model.crewinfo"></b-form-input>
      </b-input-group>
      <div v-if="this.model.send2wf == 1">
        <label>Workflow process history</label>
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th>Comment</th>
                <th width="120px">Complete Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                <td>
                  {{ row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>{{ row.crewnik }} | {{ row.crewname }}</td>
                <td>
                  {{ row.actiontake }}
                  <p v-if="row.crewname !== row.actionBy">{{ row.actionBy }}</p>
                </td>
                <td>{{ row.message }}</td>
                <td>
                  <span v-if="row.completeddate">{{
                    row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")
                  }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="5" class="subtotal"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-row class="justify-content-center mt-1">
          <b-button variant="primary" @click="printApproval"
            ><i class="fa fa-print"></i> Print Approval</b-button
          >
          <b-button
            variant="danger"
            class="ml-1"
            v-if="
              model.iscomplete == 0 ||
              model.isreject == 1 ||
              approvalHistory.length == 0
            "
            @click="showApprovalCancelConfirm = true"
          >
            <i class="fa fa-undo"></i> Cancel Approval</b-button
          >
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showApprovalConfirm = false"
          >
            <i class="fa fa-close"></i> Close</b-button
          >
        </b-row>
      </div>
      <div no-body v-else>
        <div class="report-wraper mt-2">
          <table width="100%">
            <thead>
              <tr>
                <th width="200px">Attached Date</th>
                <th>File Name</th>
                <th width="100px">Attached By</th>
                <th width="40px">action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in attachmens" :key="row.attachmentKey">
                <td>
                  {{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
                </td>
                <td>
                  <b-link @click="attachmentDownload(row)">{{
                    row.attchFileNm
                  }}</b-link>
                </td>
                <td>{{ row.createby }}</td>
                <td>
                  <div class="text-center" v-if="model.iscomplete == 0">
                    <a
                      href="javascript:void(0)"
                      class="text-danger"
                      @click="delAttachment(row)"
                    >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <label>Add Attachment</label>
        <b-form-file
          v-model="file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
        <div class="mt-3">
          Selected file: <strong>{{ file ? file.name : "" }} </strong>
          <span>Filesize:{{ bytesToKB.showFileSize(file) }}</span>
        </div>
        <b-row class="justify-content-center mt-1" v-if="showConfirmNoFile">
          <label style="width: 260px !important"
            >Send without attachment, are you sure?</label
          >
          <b-form-radio-group v-model="confirmNoFile" class="ml-1">
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-row>
        <b-row class="justify-content-center mt-1">
          <b-button variant="primary" @click="approval"
            ><i class="fa fa-paper-plane"></i> Send to Workflow</b-button
          >
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showApprovalConfirm = false"
          >
            <i class="fa fa-close"></i> Close</b-button
          >
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="showApprovalCancelConfirm"
      title="Remove from workflow Approval Process?"
      :centered="true"
      @ok="approvalUndo"
    >
      <p class="mb-1">
        The selected a row of data will be removed from Workflow?
      </p>
    </b-modal>

    <b-modal
      v-model="showAttachment"
      header-bg-variant="primary"
      title="Attachment"
      size="lg"
      :centered="true"
      ok-only
    >
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend
              ><label>Requesition No.</label></b-input-group-prepend
            >
            <b-form-input v-model="model.nomor" readonly></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="report-wraper">
        <table width="100%">
          <thead>
            <tr>
              <th width="200px">Attached Date</th>
              <th>File Name</th>
              <th width="100px">Attached By</th>
              <th width="40px">action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in attachmens" :key="row.attachmentKey">
              <td>
                {{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}
              </td>
              <td>
                <b-link @click="attachmentDownload(row)">{{
                  row.attchFileNm
                }}</b-link>
              </td>
              <td>{{ row.createby }}</td>
              <td>
                <div class="text-center" v-if="model.iscomplete == 0">
                  <a
                    href="javascript:void(0)"
                    class="text-danger"
                    @click="delAttachment(row)"
                  >
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div no-body v-if="model.iscomplete == 0">
        <label>Add Attachment</label>
        <b-form-file
          v-model="file"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
        <b-row class="mt-1">
          <span class="p-2"
            >Selected File:
            <strong>{{ file ? file.name : "" }}</strong> Filesize:{{
              bytesToKB.showFileSize(file)
            }}</span
          >
          <b-button
            variant="success"
            @click="attachmentSave"
            class="sm"
            v-if="file"
            ><i class="fa fa-paperclip"></i> Add Attachment</b-button
          >
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-expense {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: auto;
    }
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
  .input-group {
    .input-group-prepend {
      label {
        width: 110px !important;
      }
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import task from "../../apis/task";
import expense from "../../apis/expense";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import bytesToKB from "../../libs/filesize-byte2kb";
toastr.init();

export default {
  components: { Loading },
  data() {
    return {
      bytesToKB,
      showFilter: false,
      showDelConfirm: false,
      showAttachment: false,
      use_wfservice: this.$store.state.user.use_wfservice,
      showApprovalConfirm: false,
      approvalHistory: [],
      file: null,
      confirmNoFile: false,
      attachmens: [],
      showConfirmNoFile: "",
      showApprovalCancelConfirm: false,
      isLoading: false,
      showReport: false,
      reportUrl: null,
      model: {},
      uanguser: this.$store.state.user.matauang,
      items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        sortBy: "tglRequ",
        sortDesc: true,
        DimCol: "Dim1",
        outstand: "",
        // crewkey:this.$store.state.user.crewkey
        createby: this.$store.state.user.username,
      },
      dataList: {
        YesNoAll: dropdown.YesNoAll,
      },
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "nomor",
          thStyle: "width:100px",
          label: "Trx. Number",
          sortable: true,
        },
        {
          key: "tglRequ",
          thStyle: "width:90px",
          label: "Trx. Date",
          sortable: true,
        },
        {
          key: "keterangan",
          label: "Description",
          sortable: true,
        },
        {
          key: "crewinfo",
          label: "Create By",
          sortable: true,
        },
        {
          key: "dibayarke",
          label: "Paid To",
          sortable: true,
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true,
        },
        {
          key: "jumlah",
          label: "Requested Amount",
          thStyle: "width:110px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "issuccess",
          label: "Approval Status",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nilaiByr",
          label: "Paid",
          thStyle: "width:110px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nomorbank",
          label: "Trx.Bank/Cash",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "outstand",
          label: "Outstanding",
          thStyle: "width:110px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      const dims = this.$store.state.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        fields.push({
          key: `${dims[i].value}Txt`,
          thStyle: "width:100px",
          label: dims[i].text,
          sortable: true,
        });
      }
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.expreqlist) {
        this.tblData[key] = filter.expreqlist[key];
        filtered = true;
      }
      if (filtered === true) {
        this.showFilter = filtered;
        delete filter.expreqlist;
        this.$store.commit("filter", filter);
        // this.$store.commit("filter", {});
      }
      this.isLoading = true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.DimColInfo = (
        this.dimension.find((d) => d.value === this.tblData.DimCol) || {}
      ).text;

      const list = await expense.list(this.tblData);
      this.items = list;
      this.isLoading = false;
      return list;
    },
    refresh() {
      this.$refs.table.refresh();
    },
    search() {
      this.tblData.page = 1;
      this.$refs.table.refresh();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    clearFilter() {
      this.tblData.kodeaccc = "";
      this.tblData.namaacc = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.dibayarke = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
    },
    saveFilter() {
      const keys = [
        "uraian",
        "DimCol",
        "DimColInfo",
        "DimVal",
        "tgl1",
        "tgl2",
        "outstand",
        "nomor",
        "dibayarke",
        "kodeacc",
        "namaacc",
        "isProject",
        "crewkey",
        "crewname",
        "final",
      ];
      let filtered = false;
      const expreqlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          expreqlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        expreqlist.page = this.tblData.page;
        expreqlist.limit = this.tblData.limit;
        expreqlist.sortBy = this.tblData.sortBy;
        expreqlist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.expreqlist = expreqlist;
        this.$store.commit("filter", filter);
      }
    },
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    getAttachment: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await task.getAttachment({ taskkey: record.expenKey });
        this.attachmens = data;
        this.showAttachment = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    attachmentSave: async function (evt) {
      evt.preventDefault();
      if (this.invalidFile) {
        console.log("validation : ", this.$v.file);
        console.log("model : ", this.file);
        //   this.showAddAttachment=true;
        toastr.error("Please choose a file");
      } else {
        toastr.info(`Attachment Save`);
        this.isLoading = true;
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
          formData.append("tablekey", this.model.expenKey);
          formData.append("tableName", "expenreimburs");
          formData.append("filesize", bytesToKB.showFileSize(this.file));
          const response = await task.attachmentSave(formData);
          const data = await task.getAttachment({
            taskkey: this.model.expenKey,
          });
          this.attachmens = data;
          this.file = null;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        await task.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    delAttachment: async function (obj) {
      const pesan = `Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal
        .msgBoxConfirm(pesan, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value == true) {
            this.isLoading = true;
            try {
              await task.delAttachment(obj);
              const data = await task.getAttachment({
                taskkey: this.model.requestkey,
              });
              this.attachmens = data;
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
              console.log("error : ", error);
              if (error.sql) {
                toastr.error(error.sql, "ERROR MESSAGE", 10000);
              } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
              } else if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
            }
          }
          // this.close();
        })
        .catch((err) => {
          // An error occurred
        });
    },

    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.print();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },

    add() {
      this.saveFilter();
      router.push({
        name: "advance.expreimbursfrm",
        params: { crewkey: this.$store.state.user.crewkey },
      });
    },
    edit: function () {
      if (this.model.expenKey) {
        this.saveFilter();
        router.push({
          name: "advance.expreimbursfrm",
          params: { expenKey: this.model.expenKey },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model.expenKey) {
        if (this.model.send2wf == 0) {
          this.showDelConfirm = true;
        } else {
          toastr.warn("Approval has been sent and cannot be deleted!");
        }
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      this.isLoading = true;
      await expense.remove(this.model);
      this.refresh();
      // const index= this.items.findIndex(r => (r.expenKey==this.model.expenKey));
      // this.items.splice(index, 1);
      this.isLoading = false;
    },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    approvalConfirm: async function () {
      if (this.model.expenKey) {
        this.attachmens = [];
        if (this.model.send2wf == 1) {
          try {
            const data = await task.approvalhistory({
              key: this.model.expenKey,
            });
            this.approvalHistory = data;
          } catch (error) {
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
        this.model.orderdate = this.model.orderdate
          ? moment(this.model.orderdate).format("YYYY-MM-DD")
          : "";
        this.showApprovalConfirm = true;

        const data = await task.getAttachment({ taskkey: this.model.expenKey });
        this.attachmens = data;
      } else {
        toastr.warn(
          "Please select a row that want to be sent to workflow Approval!"
        );
      }
    },
    approval: async function (evt) {
      evt.preventDefault();
      try {
        const formData = new FormData();
        if (!this.file && this.attachmens.length == 0) {
          toastr.error(
            "Send Approval requires attached files!",
            "WARNING MESSAGE",
            10000
          );
          return;
        }
        // if (this.confirmNoFile==false){
        //   toastr.info('Send without attachment, are you sure?');
        //   this.showConfirmNoFile=true;
        //   return;
        // }

        if (this.file) {
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
        }

        formData.append("tablekey", this.model.expenKey);
        this.showApprovalConfirm = false;
        this.isLoading = true;

        const resp = await expense.approval(formData);
        this.model.send2wf = 1;
        this.refresh();
        this.isLoading = false;
        this.attachmens = [];
        this.file = null; // Reset file setelah berhasil

        if (resp.message) {
          toastr.warn(resp.message, "warning", 10000);
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    approvalUndo: async function () {
      this.isLoading = true;
      try {
        await expense.approvalUndo(this.model);
        this.model.send2wf = 0;
        this.showApprovalConfirm = false;
        this.refresh();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    printApproval: async function () {
      if (this.model.expenKey) {
        this.isLoading = true;
        try {
          this.showReport = true;
          this.reportUrl = await task.approvalprint({
            key: this.model.expenKey,
          });
          this.isLoading = false;
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    print: async function () {
      if (this.model.expenKey) {
        try {
          this.showReport = true;
          this.reportUrl = await expense.print(this.model);
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        this.tblData.DimColInfo = (
          this.dimension.find((d) => d.value === this.tblData.DimCol) || {}
        ).text;
        const response = await expense.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push("/advance/home");
    },
  },
};
</script>
